import { PsDocumentStat } from './PsDocumentStat';

export class PsDocumentStats {

    _stats; // PsDocumentStat[]

    constructor(stats) {
        this._stats = stats;
    }

    static null() {
        return new this([]);
    }

    static fromAPIDocumentStats(apiStats) {
        const stats = apiStats.map((s) => PsDocumentStat.fromAPIDocumentStat(s));

        return new this(stats);
    }

    stats() {
        return this._stats;
    }

    chartData() {
        const data = [];
        const backgroundColor = [];

        let totalValue = 0;

        this._stats.forEach((stat) => {
            totalValue += stat.total();
            data.push(stat.total());
            backgroundColor.push(stat.color());
        });

        if ( totalValue === 0 ) {
            data.push(1);
            backgroundColor.push('#9E9E9E');
        }

        return {
            datasets: [
                {
                    data,
                    backgroundColor,
                },
            ],
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/company/PsDocumentStats.js